function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("path", {
  d: "M17.16731 50H8.34116a.96128.96128 0 01-.96154-.96154V28.0696H.96154A.96128.96128 0 010 27.10806v-8.54633a.96158.96158 0 01.96154-.96154h6.41855v-5.34151C7.38009 4.69736 11.96054 0 19.33359 0A61.93931 61.93931 0 0126.055.34508a.96118.96118 0 01.83571.95309v7.644a.96128.96128 0 01-.96154.96154l-4.526.00188c-2.802 0-3.2743.98689-3.2743 3.19918v4.49547h7.50169a.96233.96233 0 01.954 1.08455l-1.10239 8.54633a.96168.96168 0 01-.954.83853h-6.3993v20.96881A.961.961 0 0117.16731 50zM9.3027 48.07692h6.90307V27.10806a.961.961 0 01.96154-.96154h6.51574l.85355-6.62325h-7.36929a.96129.96129 0 01-.96154-.96154v-5.457c0-2.38507.59064-5.12226 5.19738-5.12226l3.56445-.00141V2.163c-1.21413-.10892-3.31467-.23991-5.634-.23991-6.28052 0-10.03042 3.864-10.03042 10.3356v6.30305a.96159.96159 0 01-.96154.96154H1.92308v6.62325h6.41808a.9613.9613 0 01.96154.96154z",
  fill: "#3c5a9a",
  "data-name": "Layer 1"
}));

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 26.89068 50",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.a09b2708.svg";
export { ForwardRef as ReactComponent };